import { getCurrentUser } from '@client/features/auth/utils/get-current-user';
import { SoftwareFeature } from '@client/features/software-feature/types';

/**
 * Determine if the currently authenticated User has access to the given
 * software feature. The backend factors in logic such as whether the User's
 * Subscription Plan supports that feature, and if this User has limited
 * feature access in the Workspace they're working in.
 */
export function currentUserHasFeatureAccess(feature: SoftwareFeature): boolean {
  const user = getCurrentUser();

  return user.featuresAllowed.includes(feature);
}
